module.exports = __webpack_public_path__ + "img/footer-payment-methods.dc59dfdd.png";